import * as ouiStyle from './root';
export * from './root';
export default ouiStyle;
